<template>
  <div>
    <success-fade-alert ref="alert" :msg="alert.success" />
    <fade-alert-danger ref="danger" :msg="alert.error" />
    <b-row>
      <h2>
        {{ this.$t("vehicleAvailableReason.vehicleAvailableReason") }}
      </h2>
    </b-row>

    <b-row>
      <router-link :to="'./create/'">
        <b-button size="sm">
          {{ this.$t("geral.create") }}
        </b-button>
      </router-link>

      <b-table
        ref="vehicleAvaliableReasonTable"
        :busy.sync="isBusy"
        :items="tableProvider"
        :fields="fields"
        :filter="filter"
        :filter-debounce="600"
        :per-page="tablePerPage"
        :current-page="tableCurrentPage"
        :sort-by="sortBy"
        :sort-desc="sortDesc"
        striped
        hover
      >
        <template #thead-top>
          <b-tr style="">
            <b-th></b-th>
            <b-th>
              <b-form-input placeholder="Id" v-model="filter.id" />
            </b-th>
            <b-th>
              <b-form-input
                :placeholder="$t('geral.name')"
                v-model="filter.name"
              />
            </b-th>
            <b-th>
              <vehicle-available-reason-options
                :availabilityReason.sync="filter.availabilityReason"
                :modelstate.sync="modelstate"
              />
            </b-th>
            <b-th>
              <b-form-select
                v-model="filter.active"
                :options="optionsBoolean"
              />
            </b-th>
          </b-tr>
        </template>

        <template #cell(actions)="data">
          <router-link :to="'./edit/' + data.item.id">
            <b-button size="sm">
              {{ $t("checklist.form.edit") }}
            </b-button>
          </router-link>
          <b-button
            v-if="data.item.active"
            style="margin-left: 5px"
            size="sm"
            @click="deletar(data.item.id)"
          >
            {{ $t("vehicleAvailableReason.disable") }}
          </b-button>

          <b-button
            v-else-if="!data.item.active"
            style="margin-left: 5px"
            size="sm"
            @click="Ativar(data.item.id)"
          >
            {{ $t("vehicleAvailableReason.activate") }}
          </b-button>
        </template>
      </b-table>
    </b-row>

    <b-row>
      <b-col sm="5" md="5" lg="5" class="mt-1">
        <b-pagination
          v-model="tableCurrentPage"
          :total-rows="tableRowCount"
          :per-page="tablePerPage"
          first-number
          last-number
          aria-controls="table-tabela-proceda"
        />
      </b-col>

      <b-col sm="4" md="4" lg="4" class="mt-2">
        <label for="perPageSelect">
          Exibindo {{ paginationFrom }} até {{ paginationTo }} de um total de
          {{ tableRowCount }}
        </label>
      </b-col>

      <b-col sm="3" md="3" lg="3">
        <b-form-group
          label-cols-md="6"
          label="Por página"
          label-align-md="right"
          label-for="perPageSelect"
        >
          <b-form-select
            class="mt-1"
            v-model="tablePerPage"
            id="perPageSelect"
            size="sm"
            :options="tablePageOptions"
          />
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "VehicleAvailableReasonList",
  components: {
    "vehicle-available-reason-options": () =>
      import(
        "@/components_rms/vehicle/VehicleAvailableReason/VehicleAvailableReasonOptions.vue"
      ),
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
  },
  data() {
    return {
      alert: {
        error: "",
        success: "Setor desativado com sucesso"
      },
      modelstate: {},
      tablePerPage: 5,
      tablePageOptions: [5, 10, 25, 50, 100, 150],
      tableCurrentPage: 1,
      tableRowCount: 0,
      fields: [
        {
          key: "actions",
          label: "",
          tdClass: "actions",
          thStyle: "width: 100px",
        },
        {
          key: "id",
          sortable: true,
          label: this.$t("tracking.table.id"),
          thStyle: "width: 80px",
        },
        {
          key: "name",
          sortable: true,
          label: this.$t("vehicleAvailableReason.name"),
          thStyle: "width: 250px",
        },
        {
          key: "availabilityReasonText",
          sortable: true,
          label: this.$t("vehicleAvailableReason.type"),
          thStyle: "width: 150px",
        },
        {
          key: "active",
          sortable: true,
          label: this.$t("vehicleAvailableReason.active"),
          thStyle: "width: 40px",
          formatter: (value, key, item) => {
            if (value) {
              return "Sim";
            }
            return "Não";
          },
        },
      ],
      optionsBoolean: [
        { value: 0, text: "Todos" },
        { value: 1, text: "Sim" },
        { value: 2, text: "Não" },
      ],
      sortBy: "id",
      sortDesc: false,
      isBusy: false,
      filter: {
        id: "",
        name: "",
        active: 1,
        availabilityReason: 0,
      },
    };
  },
  computed: {
    paginationFrom() {
      return this.tablePerPage * (this.tableCurrentPage - 1) + 1;
    },
    paginationTo() {
      let to = this.paginationFrom - 1 + this.tablePerPage;
      if (to > this.tableRowCount) return this.tableRowCount;
      return to;
    },
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
  },
  methods: {
    tableProvider(ctx, callback) {
      this.isBusy = true;

      let apiFilter = {
        id: ctx.filter.id,
        name: ctx.filter.name,
        active: ctx.filter.active,
        availabilityReason: ctx.filter.availabilityReason ?? 0,
        sortBy: ctx.sortBy,
        perPage: ctx.perPage,
        sortDesc: ctx.sortDesc,
        currentPage: ctx.currentPage,
      };
      this.$apiVehicle
        .post("/vehicleAvailableReason/list", apiFilter)
        .then((response) => {
          this.tableRowCount = response.data.totalItems;
          this.isBusy = false;
          this.items = response.data.items;
          callback(this.items);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
              this.isBusy = false;
            });
          } else {
            this.tableIsBusy = false;
            this.tableRowCount = 0;
            this.isBusy = false;
            callback([]);
          }
        });
      return null;
    },
    clearFields() {
      this.filter = {
        id: null,
        name: "",
        active: 1,
        availabilityReason: 0,
      };
    },
    Ativar(id) {
      this.$apiVehicle
        .put(`/vehicleAvailableReason/Activate/${id}`)
        .then((response) => {
          if (response.data.status == 500) {
            this.alert.error = response.data.title;
            this.$refs.fadeAlertDanger.show();
          } else {
            this.$refs.vehicleAvaliableReasonTable.refresh();
            this.$forceUpdate();
          }
        })
        .catch((error) => {
          console.log(error);
          if (error.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
            this.isBusy = false;
            this.tableRowCount = 0;
            
          }
        });
    },
    deletar(id) {
      this.$apiVehicle
        .put(`/vehicleAvailableReason/Deactivate/${id}`)
        .then((response) => {
          if (response.data.status == 500) {
            this.alert.error = response.data.title;
            this.$refs.fadeAlertDanger.show();
          } else {
            this.$refs.vehicleAvaliableReasonTable.refresh();
            this.$forceUpdate();
          }
        })
        .catch((error) => {
          console.log(error);
          if (error.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
            this.isBusy = false;
            this.tableRowCount = 0;
            
          }
        });
    },
  },
};
</script>